/*=========================================================================================
  File Name: moduleMapMutations.js
  Description: Map Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	CHANGE_NAVBAR_COLOR(state, val) {
		state.navbarColor = val;
	},
};
